module.exports = __webpack_public_path__ + "img/Openness.57b3bd68.svg";